import React from "react";
import "../styles/Experience.css";
import { motion } from "framer-motion";
import {VerticalTimeline, VerticalTimelineElement} from 'react-vertical-timeline-component';
import "react-vertical-timeline-component/style.min.css";
import {MdSchool, MdWork} from 'react-icons/md';

const Experience = () => {
	const fade = {
		opacity: 1,
		transition: {
			duration: 1.4,
		},
	};


	return (
		<>
			<div className='experience' id='experience'>
				<div className='container'>
					<motion.div
						initial={{ opacity: 0 }}
						whileInView={fade}
						viewport={{ once: true }}
						className='heading'>
						<p className='heading-sub-text'>What made me</p>
						<p className='heading-text'>My Experiences</p>
					</motion.div>

					
					<VerticalTimeline>
						<VerticalTimelineElement 
							className="vertical-timeline-element--education" 
							date="Sept '24"
							iconStyle={{background: "#112240", color: "#fff"}}
							icon={<MdWork></MdWork>}>
								<h3 className="vertical-timeline-element-title">
									IDS Graduate Mentor
								</h3>
								<p>
									Alfred P. Sloan Foundation Fellowship, MA, US
								</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement 
							className="vertical-timeline-element--work" 
							date="Sept '24"
							iconStyle={{background: "#112240", color: "#fff"}}
							icon={<MdWork></MdWork>}>
								<h3 className="vertical-timeline-element-title">
									Backend Engineer Intern
								</h3>
								<p>
									Building Assure PBC, Concord, MA, US
								</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement 
							className="vertical-timeline-element--education" 
							date="Sept '24"
							iconStyle={{background: "#112240", color: "#fff"}}
							icon={<MdSchool></MdSchool>}>
								<h3 className="vertical-timeline-element-title">
									Doctor of Philosophy - PhD, Computer Science
								</h3>
								<p>
									University of Massachusettes Boston, MA, US
								</p>
						</VerticalTimelineElement>


						<VerticalTimelineElement 
							className="vertical-timeline-element--work" 
							date="Jan '24"
							iconStyle={{background: "#112240", color: "#fff"}}
							icon={<MdWork></MdWork>}>
								<h3 className="vertical-timeline-element-title">
									Graduate Teaching Assistant
								</h3>
								<p>
									University of Massachusettes Boston, MA, US
								</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement 
							className="vertical-timeline-element--work" 
							date="Sept '23"
							iconStyle={{background: "#112240", color: "#fff"}}
							icon={<MdWork></MdWork>}>
								<h3 className="vertical-timeline-element-title">
									Backend Engineer Intern
								</h3>
								<p>
									Building Assure PBC, Concord, MA, US
								</p>
						</VerticalTimelineElement>

						<VerticalTimelineElement 
							className="vertical-timeline-element--work" 
							date="Mar '23"
							iconStyle={{background: "#112240", color: "#fff"}}
							icon={<MdWork></MdWork>}>
								<h3 className="vertical-timeline-element-title">
									Software Developer
								</h3>
								<p>
									Venture Development Center at UMass Boston, MA, US
								</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement 
							className="vertical-timeline-element--education" 
							date=" Sept '22"
							iconStyle={{background: "#112240", color: "#fff"}}
							icon={<MdSchool></MdSchool>}>
								<h3 className="vertical-timeline-element-title">
									Master of Science, Computer Science
								</h3>
								<p>
									University of Massachusettes Boston, MA, US
								</p>
						</VerticalTimelineElement>
						
						<VerticalTimelineElement 
							className="vertical-timeline-element--work" 
							date="Apr '20"
							iconStyle={{background: "#112240", color: "#fff"}}
							icon={<MdWork></MdWork>}>
								<h3 className="vertical-timeline-element-title">
									Senior Software Engineer
								</h3>
								<p>
									Radix Analytics Pvt Ltd, Ahmedabad, India
								</p>
						</VerticalTimelineElement>
						
						<VerticalTimelineElement 
							className="vertical-timeline-element--work" 
							date="Nov '18"
							iconStyle={{background: "#112240", color: "#fff"}}
							icon={<MdWork></MdWork>}>
								<h3 className="vertical-timeline-element-title">
									Software Engineer
								</h3>
								<p>
									Radix Analytics Pvt Ltd, Ahmedabad, India
								</p>
						</VerticalTimelineElement>
						
						<VerticalTimelineElement 
							className="vertical-timeline-element--education" 
							date="Sept '14"
							iconStyle={{background: "#112240", color: "#ccd6f6"}}
							icon={<MdSchool></MdSchool>}>
								<h3 className="vertical-timeline-element-title" color="#ccd6f6">
									Bachelor of Engineering, Computer Science Engineering
								</h3>
								<p>
									Walchand Institute of Technology, Solapur, India
								</p>
						</VerticalTimelineElement>
					</VerticalTimeline>
				</div>
			</div>
		</>
	);
};

export default Experience;
